import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import store from '../src/reducer/root';
import AppContent from './AppContent';
import FJAction from './action/FJAction';
import FJLocalStore from './store/FJLocalStore';
import FJViewConstant from './constant/FJViewConstant';
import FJUtil from './util/FJUtil';

function App() {
    const [isLoading, setIsLoading] = useState(true);

    const preLoad = async () => {
        // 加载语言
        const __loadLanguage = () => {
            return new Promise((resolve, reject) => {
                FJLocalStore.initLanguage(() => {
                    resolve();
                });
            });
        };

        try {
            await __loadLanguage();
            setIsLoading(false);

            // 接受了cookie，就允许第三方cookie加载（flexclip应对谷歌检查需求， 2024.3.1）
            if (localStorage.getItem('cookie_privacy_shown') !== '2') {
                store.dispatch(FJAction.changeCountryCode(''));
                store.dispatch(FJAction.loadCaptchaApi());
            }
        } catch (e) {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        preLoad();
    }, []);

    if (isLoading) {
        return null;
    }

    return (
        <Provider store={store}>
            <AppContent />
        </Provider>
    );
}

export default App;

window.needLoginRecaptcha = false;

window.openLogin = obj => {
    store.dispatch(FJAction.openLoginView(obj));
};
if (window.fj && window.fj.event && window.fj.event.subscribe) {
    window.fj.event.subscribe('OPEN_LOGIN', obj => {
        store.dispatch(FJAction.openLoginView(obj));
    });
    window.fj.event.subscribe('CLOSE_LOGIN_PANEL', () => {
        // 关闭弹窗登录面板
        store.dispatch(FJAction.closeLoginView());
    });
}
window.openGoogleLoginView = function (id_token, type, options) {
    try {
        FJUtil.setLoginInfo({});
        const { email, is_need_restore, expiration_days } = JSON.parse(options);
        if (is_need_restore === 1) {
            FJUtil.setLoginInfo({ id_token, type, email });
            store.dispatch(FJAction.changeStep(FJViewConstant.RESTORE_ACCOUNT));
            store.dispatch(FJAction.setRestoreExpireTimeAction(expiration_days));
        } else {
            if (type === 'google') {
                store.dispatch(FJAction.sendGoogleTokenAction(id_token));
            } else if (type === 'facebook') {
                store.dispatch(FJAction.sendFacebookTokenAction(id_token));
            }
        }
    } catch (e) {}
};
